import React, { useState, useEffect, useRef } from 'react';
import { useStateValue } from "../GlobalState/StateProvider";
import { useNavigate } from 'react-router-dom';
import { useApiHook } from '../Helper/ApiHook/apiHook';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';

const IDWOverlayPanel = ({ data }) => {
    let navigate = useNavigate();
    const [{ user }, dispatch] = useStateValue();
    const op = useRef(null);

    useEffect(() => {
        console.log(data);
    }, []);





    return (

        <div className="row justify-content-center ">
            {data && data.length > 60 ?
                <>
                    <span>{data && data.substring(0, 18)}...
                        <Button icon="pi pi-comment" className="p-button-rounded p-button-warning p-button-text" aria-label="Info" onClick={(e) => op.current.toggle(e)} />
                    </span>
                    <OverlayPanel ref={op} showCloseIcon dismissable id="overlay_panel" style={{ maxWidth: '80%' }} className="overlaypanel-demo">
                        <div  style={{ whiteSpace: 'break-spaces', fontSize: '12px' }}>
                            {data}
                        </div>
                    </OverlayPanel>
                </>
                : <div style={{ whiteSpace: 'break-spaces', fontSize: '14px' }}>
                    {data}
                </div>
            }

        </div>



    );
}
export default IDWOverlayPanel;
